module.exports = __webpack_public_path__ + "img/RackMultipart20180729-7436-1g4yyeh.c4174322.jpg";